'use es6'; // When deployed, the pricing pages should just be under
// /public-pricing, however when testing locally and on the proxy during dev
// we have differnet URLs (e.g. /public-pricing-pt-br-service) that'll break
// if we dont grab the path dynamically

export default (() => {
  return `/${window.location.pathname.split('/')[1]}`;
});